import { log, supabase } from ".";

export const updateIntermediario = async (updatedData) => {
  try {
    const id = updatedData.id;
    delete updatedData.id;
    updatedData.lastupdate = new Date().toISOString();
    const { data, error } = await supabase.update("intermediarios", updatedData, id);

    if (error) throw error;

    return data;
  } catch (error) {
    log.error("updateIntermediario", error);
    throw error;
  }
};
